import { useState } from "react";
import { motion } from "framer-motion";
import { Eyebrow, MaskLines, Reveal } from "./Motion";
import { Lightbox } from "./Lightbox";
import { CLIENTS } from "../data/content";

export const Clients = () => {
  const [active, setActive] = useState(null);
  return (
    <section id="clients" data-testid="clients-section" className="bg-[#F3EFEA]">
      <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 sm:py-32">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Eyebrow>My clients</Eyebrow>
            <h2 className="mt-6 font-display text-4xl leading-[1.04] sm:text-5xl lg:text-6xl">
              <MaskLines lines={["Real women,", <span key="i" className="italic text-[#8A6A3E]">real transformations.</span>]} />
            </h2>
          </div>
          <Reveal className="lg:col-span-5" delay={0.1}>
            <p className="text-lg leading-relaxed text-[#5E5953]" data-testid="clients-intro">
              Every look below was created for a client — her body, her life, her budget. Click any photo to see it closer.
            </p>
          </Reveal>
        </div>

        <div className="-mx-5 mt-14 flex min-w-0 snap-x snap-mandatory gap-3 overflow-x-auto px-5 no-scrollbar sm:-mx-10 sm:px-10 lg:mx-0 lg:grid lg:grid-cols-5 lg:gap-x-3 lg:gap-y-10 lg:overflow-visible lg:px-0">
          {CLIENTS.map((c, i) => (
            <motion.button
              type="button" key={c.src} onClick={() => setActive(i)} data-testid={`client-look-${i}`}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative aspect-[3/4] w-[72vw] shrink-0 snap-start overflow-hidden bg-[#E5DFD5] text-left sm:w-[40vw] lg:w-auto ${i % 5 % 2 ? "lg:mt-10" : ""}`}
            >
              <img src={c.src} alt={c.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#1A1816]/70 to-transparent p-4 pt-10 text-[#FAF8F5] opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <span className="block font-display text-xl">{c.title}</span>
                <span className="block text-sm text-[#CFC8BD]">{c.note}</span>
              </span>
            </motion.button>
          ))}
        </div>

        <Reveal className="mt-16 max-w-3xl border-t border-[#DDD6CB] pt-10" delay={0.1}>
          <p className="text-sm tracking-[0.2em] uppercase text-[#8A6A3E]" data-testid="clients-specialty-label">My specialty</p>
          <p className="mt-4 font-display text-2xl leading-snug sm:text-3xl" data-testid="clients-specialty">
            I specialise in working with women — shaping the personal style of a woman 45+.
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#5E5953]">
            This is what my clients look like after we work together: confident, modern and completely themselves.
          </p>
        </Reveal>
      </div>
      <Lightbox looks={CLIENTS} index={active} setIndex={setActive} title="My clients" id="clients" />
    </section>
  );
};
